// extracted by mini-css-extract-plugin
module.exports =  {"badge":"BadgePrimitive-module__badge___Pdzfr","badge__label":"BadgePrimitive-module__badge__label___o37gH","badge__divider":"BadgePrimitive-module__badge__divider___EVFU8"};